module.exports = __webpack_public_path__ + "static/media/biAPE.f8b374cd.png";